module.exports = __webpack_public_path__ + "static/media/centre-appel2.52de5669.png";